(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3AdjustedGrossScore', {
            templateUrl: 'app/shared/score-posting/adjusted-gross-score.component.html',
            controller: AdjustedGrossScoreComponent,
            bindings: { score: '<' },
            require: { form: '^^form' }
        });

    var noop = angular.noop,
        isDefined = angular.isDefined,
        isUndefined = angular.isUndefined;

    AdjustedGrossScoreComponent.$inject = ['$scope', 'escInfoModal', '$timeout'];
    function AdjustedGrossScoreComponent($scope, escInfoModal, $timeout) {
        var ctrl = this,
            saved = {};

        ctrl.showEscInfoModal = showEscInfoModal;
        $scope.$watch('$ctrl.score.isHoleByHole', holeByHoleWatchAction);

        function showEscInfoModal() {
            escInfoModal().result.catch(noop);
        }
        function holeByHoleWatchAction(newVal, oldVal) {
            var esc = ctrl.form.esc;
            if (newVal != oldVal) {
                saved[oldVal] = esc.$viewValue;
                // Special case - they switch back to total score which previously had an invalid value.  Restore that
                // invalid value.
                if (newVal === false && isDefined(saved[newVal]) && isUndefined(ctrl.score.esc)) {
                    esc.$setViewValue(saved[newVal]);
                    esc.$render();
                }
            }
        }
    }
})();